import * as React from "react"
import { cn } from "@/lib/utils"
import { useDeviceInfo } from "@/hooks/use-device-info"

export interface InputProps extends React.ComponentProps<"input"> {
  touchOptimized?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, touchOptimized = true, ...props }, ref) => {
    const { isMobile } = useDeviceInfo()
    
    return (
      <input
        type={type}
        className={cn(
          "flex w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2",
          "focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          
          // Mobile-optimized sizing and typography
          isMobile && touchOptimized ? [
            "h-11", // 44px minimum touch target
            "text-base", // 16px to prevent zoom on iOS
            "px-4 py-3", // Larger padding for easier touch interaction
          ] : [
            "h-10", // Standard desktop height
            "text-base md:text-sm", // Responsive text sizing
          ],
          
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
